import script from "./SelectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=027dfc5d&lang=css"

const __exports__ = script;

export default __exports__